import { render } from "./aboutVision.vue?vue&type=template&id=d4a8ac2e&scoped=true"
import script from "./aboutVision.vue?vue&type=script&lang=js"
export * from "./aboutVision.vue?vue&type=script&lang=js"

import "./aboutVision.vue?vue&type=style&index=0&id=d4a8ac2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a8ac2e"]])

export default __exports__